<template>
  <b-row>
    <span class="left-margin">
      <b-input-group size="md" prepend="SKU数">
        <b-input class="group-label_4" :value="skuSummary"/>
      </b-input-group>
    </span>
    <span class="left-margin">
      <b-input-group size="md" prepend="商品数">
        <b-input class="group-label_4" :value="productCountSummary"/>
      </b-input-group>
    </span>
    <span class="left-margin">
      <b-input-group size="md" prepend="重量">
        <b-input class="group-label_5" :value="weightSummary"/>
      </b-input-group>
    </span>
    <span class="left-margin">
      <b-input-group size="md" prepend="仕入額">
        <b-input class="group-label_6" :value="purchaseAmountSummary"/>
      </b-input-group>
    </span>
    <span class="left-margin">
      <b-input-group size="md" prepend="残数">
        <b-input class="group-label_4" :value="restQuantity"/>
      </b-input-group>
    </span>
  </b-row>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    items: { default: [] },
    totalInboundQuantity: { default: '0' }
  },
  computed: {
    totalSku()    {
      // 初期値チェック
       if (this.items === null || this.items.length === 0){
         return 0;
       }

       var skuList = [];
       var total = 0;
       for (var i=0; i<this.items.length; i++){
         if((this.items[i]['status'] !== '' && this.items[i]['status'] !== '05') || this.items[i]['delete'] || skuList.indexOf(this.items[i]['sku']) !== -1){
           continue;
         }
         skuList.push(this.items[i]['sku']);
         total += 1;
       }
       return total;
    },
    totalProcut() {
      // 初期値チェック
       if (this.items === null || this.items.length === 0){
         return 0;
       }
       var total = 0;
       for (var i=0; i<this.items.length; i++){
         if((this.items[i]['status'] !== '' && this.items[i]['status'] !== '05') || this.items[i]['delete']){
           continue;
         }
         total += utility.toNumber(this.items[i]['quantity']);
       }
       return total;
    },
    totalWeight() {
      // 初期値チェック
       if (this.items === null || this.items.length === 0){
         return 0;
       }
       var total = 0;
       for (var i=0; i<this.items.length; i++){
         if((this.items[i]['status'] !== '' && this.items[i]['status'] !== '05') || this.items[i]['delete']){
           continue;
         }
         total += this.items[i]['weight'] * utility.toNumber(this.items[i]['quantity']);
       }
       total = Math.floor(total * Math.pow(10,2)) / Math.pow(10,2);
       return total;
    },
    totalAmount() {
      // 初期値チェック
       if (this.items === null || this.items.length === 0){
         return 0;
       }
       var total = 0;
       for (var i=0; i<this.items.length; i++){
         if((this.items[i]['status'] !== '' && this.items[i]['status'] !== '05') || this.items[i]['delete']){
           continue;
         }
         total += this.items[i]['price'] * utility.toNumber(this.items[i]['quantity']);
       }
       return total;
    },
    skuSummary() {
      return this.totalSku + '個';
    },
    restQuantity() {
      var restQ = this.totalInboundQuantity - this.totalProcut;
      this.$emit('updateWkDispRestVolume', restQ);
      return restQ + '個';
    },
    productCountSummary() {
      var tp = this.totalProcut;
      this.$emit('updateItemQuantity', tp);
      return tp + '個';
    },
    weightSummary() {
      return this.totalWeight + 'Kg';
    },
    purchaseAmountSummary() {
      return this.formatPrice(this.totalAmount);
    },
  },
};
</script>

<style>
.left-margin {
  padding-left: 15px;
}
.group-label_4 {
  pointer-events: none;
  width: 4rem!important;
  text-align: right;
}
.group-label_5 {
  pointer-events: none;
  width: 5rem!important;
  text-align: right;
}
.group-label_6 {
  pointer-events: none;
  width: 6rem!important;
  text-align: right;
}
</style>
